import Head from 'next/head'
/* @ts-ignore */
import PrivacyPolitics from 'public/documents/PoliticaDePrivacidad.docx'
/* @ts-ignore */
import PrivacyPoliticsEng from 'public/documents/PrivacyPoliticsEng.docx'
import React from 'react'
import LegalDocument from '@components/legal-document'
import { useTranslations } from 'next-intl'

import type { GetStaticPropsContext, NextPage } from "next";
import HeadMeta, { IHeadMetaComponent } from '@components/head-meta'
import { CKeyWordsPages } from 'shared/models/const/keywords.const'
import { useRouter } from 'next/router'
export async function getStaticProps({ locale }: GetStaticPropsContext) {
  return {
    props: {
      locale,
      messages: (await import(`@lang/${locale}.json`)).default,
    },
  };
}

const PoliticaPrivacidad: NextPage = (props: any) => {
  const document = props.locale === "es" ? PrivacyPolitics : PrivacyPoliticsEng;
  const router = useRouter()
  const metaData: IHeadMetaComponent = {
    title: "privacyPolicy",
    description: "privacyPolicy",
    url: router.asPath,
    og_type: "page-privacy-policy",
  }
  return (
    <>
      <HeadMeta {...metaData}></HeadMeta>
      <LegalDocument document={document} />
    </>
  );
};

export default PoliticaPrivacidad;

